import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Menu } from "semantic-ui-react";
import {Link} from "react-router-dom";
import TextIcon from "./TextIcon";
import SubTextIcon from "./SubTextIcon";
import {logOut} from '../../actions/auth'
import Dls from '../../lib'

class SidebarComponent extends Component {
    logOut = () => {
        this.props.logOut();
        window.location.reload();
    }

    hasWooIntegration = () => {
        if (this.props.integrations.woo) {
            return true;
        }
        return false;
    }

    hasLinksIntegration = () => {
        if (this.props.integrations.links) {
            return true;
        }
        return false;
    }

    hasQbIntegration = () => {
        if (this.props.integrations.qb.id) {
            return true;
        }
        return false;
    }

    hasHostIntegration = () => {
        if (this.props.integrations.host) {
            return true;
        }
        return false;
    }

    render() {
        const {sideBarClosed, currentLocation, integrations} = this.props;
        const {pathname} = currentLocation;
        return (
            <div
                className={(sideBarClosed ? "small-side " : "") + "side"}
            >
                <Menu
                    fixed="left"
                    borderless
                    className={
                        (sideBarClosed ? "small-side" : "") + " side"
                    }
                    vertical
                >
                    <Menu.Item
                        as={Link}
                        to={"/"}
                        name="dashboard"
                        active={pathname === "/"}
                        onClick={this.handleItemClick}
                    >
                        <TextIcon
                            hideText={sideBarClosed}
                            color="black"
                            name="home"
                        >
                            Dashboard
                        </TextIcon>
                    </Menu.Item>

                    <Menu.Item
                        as={Link}
                        to={`/inventories/${Dls.pagination.inventories()}`}
                        name="dashboard"
                        active={pathname.substr(1,11) === "inventories"}
                        onClick={this.handleItemClick}
                    >
                        <TextIcon
                            hideText={sideBarClosed}
                            color="black"
                            name="barcode"
                        >
                            Inventory
                        </TextIcon>
                    </Menu.Item>

                    <Menu.Item as={Link}
                        to={`/settings/ecommerce/products/${Dls.pagination.sprProducts()}`}
                        name="settings-sprp"
                        active={pathname.substr(0,28) === '/settings/ecommerce/products'}
                        onClick={this.handleItemClick}
                    >
                        <TextIcon
                            hideText={sideBarClosed}
                            color="black"
                            name="cubes"
                        >
                            SPR Products
                        </TextIcon>
                    </Menu.Item>
                    
                    <Menu.Item>
                        <Menu.Header>
                            <TextIcon
                                hideText={sideBarClosed}
                                name="users"
                            >
                                Relations
                            </TextIcon>
                        </Menu.Header>

                        <Menu.Menu>
                            <Menu.Item
                                as={Link}
                                to={`/customers/${Dls.pagination.relations('Customer')}`}
                                name="customer"
                                active={pathname.substr(1,9) === "customers"}
                                onClick={this.handleItemClick}
                            >
                                <SubTextIcon 
                                    name="Customers"
                                    hideText={sideBarClosed}
                                    shortName="CUS"
                                />
                            </Menu.Item>
                            <Menu.Item
                                as={Link}
                                to={`/vendors/${Dls.pagination.relations('Vendor')}`}
                                name="vendor"
                                active={pathname.substr(1,7) === "vendors"}
                                onClick={this.handleItemClick}
                            >
                                <SubTextIcon 
                                    name="Vendors"
                                    hideText={sideBarClosed}
                                    shortName="VED"
                                />
                            </Menu.Item>
                        </Menu.Menu>
                    </Menu.Item>

                    <Menu.Item>
                        <Menu.Header>
                            <TextIcon
                                hideText={sideBarClosed}
                                name="unordered list"
                            >
                                Orders
                            </TextIcon>
                        </Menu.Header>

                        <Menu.Menu>
                            <Menu.Item
                                as={Link}
                                to={`/customer-orders/${Dls.pagination.orders('Customer Order')}`}
                                name="customer-order"
                                active={pathname.substr(1,15) === "customer-orders"}
                                onClick={this.handleItemClick}
                            >
                                <SubTextIcon 
                                    name="Customer Order"
                                    hideText={sideBarClosed}
                                    shortName="CPO"
                                />
                            </Menu.Item>
                            <Menu.Item
                                as={Link}
                                to={`/vendor-orders/${Dls.pagination.orders('Vendor Order')}`}
                                name="vendor-order"
                                active={pathname.substr(1,13) === "vendor-orders"}
                                onClick={this.handleItemClick}
                            >
                                <SubTextIcon 
                                    name="Vendor Order"
                                    hideText={sideBarClosed}
                                    shortName="VPO"
                                />
                            </Menu.Item>
                            <Menu.Item
                                as={Link}
                                to={`/customer-returns/${Dls.pagination.orders('Customer Return')}`}
                                name="consumer-return"
                                active={pathname.substr(1,16) === "customer-returns"}
                                onClick={this.handleItemClick}
                            >
                                <SubTextIcon 
                                    name="Customer Return"
                                    hideText={sideBarClosed}
                                    shortName="CRM"
                                />
                            </Menu.Item>
                            <Menu.Item
                                as={Link}
                                to={`/vendor-returns/${Dls.pagination.orders('Vendor Return')}`}
                                name="vendor-return"
                                active={pathname.substr(1,14) === "vendor-returns"}
                                onClick={this.handleItemClick}
                            >
                                <SubTextIcon 
                                    name="Vendor Return"
                                    hideText={sideBarClosed}
                                    shortName="VRM"
                                />
                            </Menu.Item>
                        </Menu.Menu>
                    </Menu.Item>

                    <Menu.Item>
                        <Menu.Header>
                            <TextIcon
                                hideText={sideBarClosed}
                                name="truck"
                            >
                                Shipments
                            </TextIcon>
                        </Menu.Header>

                        <Menu.Menu>
                            <Menu.Item
                                as={Link}
                                to={`/shipments/receiving/${Dls.pagination.shipments('inbound')}`}
                                name="receiving"
                                active={pathname.substr(1,19) === "shipments/receiving"}
                                onClick={this.handleItemClick}
                            >
                                <SubTextIcon 
                                    name="Receiving"
                                    hideText={sideBarClosed}
                                    shortName="REC"
                                />
                            </Menu.Item>
                            <Menu.Item
                                as={Link}
                                to={`/shipments/shipping/${Dls.pagination.shipments('outbound')}`}
                                name="shipping"
                                active={pathname.substr(1,18) === "shipments/shipping"}
                                onClick={this.handleItemClick}
                            >
                                <SubTextIcon 
                                    name="Shipping"
                                    hideText={sideBarClosed}
                                    shortName="SHP"
                                />
                            </Menu.Item>
                        </Menu.Menu>
                    </Menu.Item>

                    <Menu.Item
                        as={Link}
                        to={`/qb/transactions/${Dls.pagination.transactions()}`}
                        name="transactions"
                        active={pathname.substr(0,16) === "/qb/transactions"}
                        onClick={this.handleItemClick}
                    >
                        <TextIcon
                            hideText={sideBarClosed}
                            color="black"
                            name="chain"
                        >
                            QB Transaction
                        </TextIcon>
                    </Menu.Item>

                    <Menu.Item
                        as={Link}
                        to={"/reports"}
                        name="reports"
                        active={pathname.substr(1,11) === "/reports"}
                        onClick={this.handleItemClick}
                    >
                        <TextIcon
                            hideText={sideBarClosed}
                            color="black"
                            name="file alternate outline"
                        >
                            Reports
                        </TextIcon>
                    </Menu.Item>

                    {this.props.me.role === 'Admin' ? <Menu.Item>
                        <Menu.Header>
                            <TextIcon
                                hideText={sideBarClosed}
                                name="settings"
                            >
                                Settings
                            </TextIcon>
                        </Menu.Header>

                        <Menu.Menu>
                            <Menu.Item
                                as={Link}
                                to={`/settings/warehouses/${Dls.pagination.warehouses()}`}
                                name="settings-warehouse"
                                active={pathname.substr(0,20) === '/settings/warehouses'}
                                onClick={this.handleItemClick}
                            >
                                <SubTextIcon 
                                    name="Warehouses"
                                    hideText={sideBarClosed}
                                    shortName="WHS"
                                />
                            </Menu.Item>

                            <Menu.Item
                                as={Link}
                                to={`/settings/users/${Dls.pagination.users()}`}
                                name="settings-users"
                                active={pathname.substr(0,14) === '/settings/users'}
                                onClick={this.handleItemClick}
                            >
                                <SubTextIcon 
                                    name="Users"
                                    hideText={sideBarClosed}
                                    shortName="USR"
                                />
                            </Menu.Item>

                            {this.hasQbIntegration() ? <Menu.Item
                                as={Link}
                                to={`/settings/mapping/qb/${integrations.qb.id}/mapping/config`}
                                name="settings-qb"
                                active={pathname.substr(0,20) === "/settings/mapping/qb"}
                                onClick={this.handleItemClick}
                            >
                                <SubTextIcon 
                                    name="Quickbook"
                                    hideText={sideBarClosed}
                                    shortName="QB"
                                />
                            </Menu.Item> : <Menu.Item
                                name="settings-qb-connect"
                            >
                                <a href='/qb/oauth/request'>Connect QB</a>
                            </Menu.Item>}


                            {this.hasLinksIntegration() ? <Menu.Item
                                as={Link}
                                to={`/settings/integrations/links/${integrations.links}/${Dls.pagination.integrationLogs()}`}
                                name="settings-links"
                                active={pathname.substr(0,28) === '/settings/integrations/links'}
                                onClick={this.handleItemClick}
                            >
                                <SubTextIcon 
                                    name="Links"
                                    hideText={sideBarClosed}
                                    shortName="3PL"
                                />
                            </Menu.Item> : null}

                            {this.hasWooIntegration() ? <Menu.Item
                                as={Link}
                                to={`/settings/integrations/woo/${integrations.woo}/${Dls.pagination.integrationLogs()}`}
                                name="settings-links"
                                active={pathname.substr(0,26) === '/settings/integrations/woo'}
                                onClick={this.handleItemClick}
                            >
                                <SubTextIcon 
                                    name="WooCommerce"
                                    hideText={sideBarClosed}
                                    shortName="WOO"
                                />
                            </Menu.Item> : null}

                            {this.hasQbIntegration() ? <Menu.Item
                                as={Link}
                                to={`/settings/integrations/qb/${integrations.qb.id}/${Dls.pagination.integrationLogs()}`}
                                name="settings-qb"
                                active={pathname.substr(0,25) === '/settings/integrations/qb'}
                                onClick={this.handleItemClick}
                            >
                                <SubTextIcon 
                                    name="QB Logs"
                                    hideText={sideBarClosed}
                                    shortName="QB"
                                />
                            </Menu.Item> : null}

                            {this.hasHostIntegration() ? <Menu.Item
                                as={Link}
                                to={`/settings/integrations/host/${integrations.host}/${Dls.pagination.integrationLogs()}`}
                                name="settings-qb"
                                active={pathname.substr(0,27) === '/settings/integrations/host'}
                                onClick={this.handleItemClick}
                            >
                                <SubTextIcon 
                                    name="Host SCM"
                                    hideText={sideBarClosed}
                                    shortName="HOST"
                                />
                            </Menu.Item> : null}

                            <Menu.Item as={Link}
                                to={'/settings/ecommerce/spr'}
                                name="settings-spr"
                                active={pathname.substr(0,23) === '/settings/ecommerce/spr'}
                                onClick={this.handleItemClick}
                            >
                                <SubTextIcon 
                                    name="SPR Uploads"
                                    hideText={sideBarClosed}
                                    shortName="UP"
                                />
                            </Menu.Item>

                            <Menu.Item as={Link}
                                to={`/settings/ecommerce/products/${Dls.pagination.sprProducts()}`}
                                name="settings-sprp"
                                active={pathname.substr(0,28) === '/settings/ecommerce/products'}
                                onClick={this.handleItemClick}
                            >
                                <SubTextIcon 
                                    name="SPR Products"
                                    hideText={sideBarClosed}
                                    shortName="SPR"
                                />
                            </Menu.Item>
                        </Menu.Menu>
                    </Menu.Item> : null}

                    <Menu.Item>
                        <Menu.Header>
                            <TextIcon
                                hideText={sideBarClosed}
                                name="user"
                            >
                                My Account
                            </TextIcon>
                        </Menu.Header>

                        <Menu.Menu>
                            <Menu.Item
                                as={Link}
                                to={`/profile`}
                                name="settings-profile"
                                active={pathname.substr(0,7) === '/profile'}
                                onClick={this.handleItemClick}
                            >
                                <SubTextIcon 
                                    name="Profile"
                                    hideText={sideBarClosed}
                                    shortName="PRO"
                                />
                            </Menu.Item>
                            
                            <Menu.Item
                                name="consumer"
                                active={pathname.substr(1,11) === "abc"}
                                onClick={() => this.logOut()}
                            >
                                Logout
                            </Menu.Item>
                        </Menu.Menu>
                    </Menu.Item>
                </Menu>
            </div>
        );
    }
}

SidebarComponent.propTypes = {
    history: PropTypes.shape({
       push: PropTypes.func.isRequired
    }).isRequired,
    sideBarClosed: PropTypes.bool,
    currentLocation: PropTypes.object,
    logOut: PropTypes.func,
    me: PropTypes.object
};

function mapStateToProps(state) {
    return {
        me: state.auth.user,
        integrations: state.system.resources.integrations
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        logOut
    }, dispatch);
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SidebarComponent);



// WEBPACK FOOTER //
// ./src/routes/parts/Sidebar.js